import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";

import axios from "axios";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { BackButton, Loader } from "@egovernments/digit-ui-react-components";

import EmployeeList from "./EmployeeList";
import EmpFileTransfer from "../../EmployeeTransfer/EmpFileTransfer";

const SearchDetails = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const user = Digit.UserService.getUser();
  const authToken = user?.access_token || null;

  const [filteredRolesInfor, setFilteredRolesInfor] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [employeeIdList, setEmployeeIdList] = useState([]);
  const [openApplicantPopup, setOpenApplicantPopup] = useState(false);
  const [fromSearchCompleted, setFromSearchCompleted] = useState({});
  const [toSearchCompleted, setToSearchCompleted] = useState({});

  const defaultValues = {};

  const {
    handleSubmit,
    control,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({
   defaultValues: {
    selectedAuthorityDeactivate: ""   // ✅ important
  },
  });
  const watchDepartment = watch("selectedDepartmentFrom");
  const watchAuthority = watch("selectedAuthorityFrom");
  const watchFromEmp = watch("employeeIdFrom");
  const watchToEmp = watch("employeeIdTo");
  // useEffect(() => {
  //   console.log("watchFromEMpEffect", watchFromEmp);
  // }, [watchFromEmp]);
  function getOtherRoleName(roles) {
    const otherRole = roles.find((role) => role.name.toLowerCase() !== "employee");
    console.log("fromGetOtherRoleName", otherRole);

    return otherRole ? otherRole.name : null;
  }
  // const selectedEmpRole = getOtherRoleName(watchFromEmp?.value?.roles || []);
  const getApplicationFlowForIndex = () => watchDepartment || "";

  const departmentList = [
    { value: "DA", label: "Development Authority" },
    { value: "AVP", label: "Awas Evam Vikas Parishad" },
  ];

  const { data: EmployeeTypes = {}, isLoadings } = Digit.Hooks.hrms.useHrmsMDMS(tenantId, "egov-hrms", "HRMSRolesandDesignation") || {};

  const { data: { BPA: { Organizations } = {} } = {}, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["Organizations"]);

  const daList = Organizations?.filter((item) => item.Type === "DA");
  const avpList = Organizations?.filter((item) => item.Type === "AVP");

  const filterDepartmentsList = (completeList) => {
    return completeList?.map((office) => ({
      value: office.Name,
      label: office.Name,
    }));
  };

 const getOfficesListForIndex = () => {
  const daOffices = filterDepartmentsList(daList || []);
  const avpOffices = filterDepartmentsList(avpList || []);
  return [...daOffices, ...avpOffices];
};


   const userDetail = Digit.SessionStorage.get("USER_DETAIL") || {};
   const SUPERUSER = Digit.Utils.superUserAccess();
   const authority = userDetail?.location1;
   const updatedAuthority = authority 
  ? `${authority} Development Authority` 
  : "";

  console.log("userDetail",updatedAuthority);

  const onSubmit = async (data) => {
    const payload = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken,
        userInfo: user?.info,
      },
      JobDelegation: data.transferDetails.map((transfer) => ({
        departmentId: transfer.departmentId,
        currentLocation: transfer.location1,
        tenantId: transfer.districtCode,
        empId: transfer.empId,
        oldDesignationRole: transfer.oldDesignationRole,
        roles: transfer.roles.map((role) => ({
          code: role.code,
          name: role.name,
          description: role.description,
        })),
        location1: transfer.district,
        location2: transfer.area,
        ward: transfer.location3,
        startDate: transfer.startDate,
        endDate: transfer.endDate,
      })),
    };

    try {
      const response = await axios.post(`${Urls.hrms.UserJobdelegationSearch}`, payload);
      setOpenApplicantPopup(true);
      return response.data;
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to submit form.");
    }
  };

  async function handleFileTransfer() {
    console.log("bothEmployees", watchFromEmp, watchToEmp);

    const filters = { oldEmpId: watchFromEmp?.value?.split("-")[0].trim() || "", newEmpId: watchToEmp?.value?.split("-")[0].trim() || "" };
    console.log("filtersFromtransfer", filters);
    if (filters.oldEmpId === "" || filters.newEmpId === "") {
      alert("Please select both Old Employee Id and New Employee Id");
      return;
    }
    if (filters.oldEmpId === filters.newEmpId) {
      alert("Old Employee Id and New Employee Id cannot be the same");
      return;
    }

    Digit.UserService.employeeFileTransfer(filters)
      .then((res) => {
        // Handle cases where API returns only status without body
        if (!res || res.status === 200 || res.status === 204 || res.success) {
          alert("Employee File Transfer Successful");
        } else {
          console.log("Unexpected Response:", res);
          alert("Employee File Transfer Failed");
        }
      })
      .catch((err) => {
        console.error("errorFromFileTransfer", err);
        alert("Employee File Transfer Failed");
      });
  }

  if (loading && isLoadings) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <React.Fragment>
      <BackButton />
      <EmployeeList
        t={t}
        control={control}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        watch={watch}
        departmentList={departmentList}
        getOfficesListForIndex={getOfficesListForIndex}
        getApplicationFlowForIndex={getApplicationFlowForIndex}
        handleFileTransfer={handleFileTransfer}
        getOtherRoleName={getOtherRoleName}
        trigger={trigger}
        setValue={setValue}       
        superUser={SUPERUSER}              // ✅ MUST
        updatedAuthority={updatedAuthority} 
      />
    </React.Fragment>
  );
};

export default SearchDetails;
